import { Grid } from '@material-ui/core'
import React, { useContext } from 'react'
import { isMobile } from 'react-device-detect'
import { BillingPeriod } from '../../../../models/insurance-models/InsuranceBillingPeriodModel'
import { BuyingInsuranceContextStore } from '../../../../context/BuyingInsuranceContext'
import { BillingPlanSpecialSelect } from './BillingPlanSectionSelect'
import { billing_period_options } from '../../../../Constants'
import '../Plans.scss'

export const BillingPlan = ({}) => {
  const offersContext = useContext(BuyingInsuranceContextStore)
  const title = 'Payment recurrence'

  return (
    <>
      {
        <Grid container>
          <Grid item xs={12} md={12}>
            <Grid container justify="space-between" alignItems="center" alignContent="space-between">
              <Grid item md={9}>
                <div className="text-body black bolder margin-right-6">{title}</div>
                <div className="text-body black margin-top-basic">
                  {offersContext.billingPeriod && billing_period_options[offersContext.billingPeriod].title}
                </div>
              </Grid>
              <Grid item md={3}>
                <div className="margin-top-small">
                  {!isMobile && (
                    <BillingPlanSpecialSelect
                      value={offersContext.billingPeriod}
                      discounts={offersContext.billingPeriodDiscount}
                      onChange={(name, value) => offersContext.setBillingPeriod(value)}
                    />
                  )}
                </div>
              </Grid>
            </Grid>

            {/* {offersContext.billingPeriod == BillingPeriod.MONTH && 
                    <Grid item md={12}>
                        <Grid item className='margin-left-negative-medium'>
                          <RectangleFrame color={'purple'}>
                            <div>{'If you choose 3 months as your payment occurrence, you can save $16 a year and to'}</div>
                           <div>{'upload the odometer photo every 3 months instead of each single month'}</div>
                           </RectangleFrame>
                        </Grid> 
                    </Grid>} */}
            {isMobile && (
              <div className="margin-top-3">
                <BillingPlanSpecialSelect
                  value={offersContext.billingPeriod}
                  discounts={offersContext.billingPeriodDiscount}
                  onChange={(name, value) => offersContext.setBillingPeriod(value)}
                />
              </div>
            )}
            {offersContext.billingPeriod && offersContext.billingPeriod != BillingPeriod.MONTH && (
              <Grid item>
                <div className="text-body margin-left-12 margin-top-basic">
                  <ul className="list-sections">
                    <li>Save ${billing_period_options[offersContext.billingPeriod].feesDiscount} on installment fees</li>
                    {offersContext.billingPeriod === BillingPeriod.THREEMONTHS && (
                      <li>Upload your odometer image only once every 3 months</li>
                    )}
                    {offersContext.billingPeriod === BillingPeriod.SIXMONTHS && (
                      <li>Upload your odometer image only once every 6 months</li>
                    )}
                    {offersContext.billingPeriod === BillingPeriod.ANNUAL && <li>Upload your odometer image only once a year</li>}
                    {offersContext.billingPeriod === BillingPeriod.ANNUAL && (
                      <li>
                        Paying in full discount - save $
                        {offersContext.billingPeriodDiscount[offersContext.billingPeriod] -
                          billing_period_options[offersContext.billingPeriod].feesDiscount}{' '}
                        more annually
                      </li>
                    )}
                  </ul>
                </div>
              </Grid>
            )}
          </Grid>
        </Grid>
      }
    </>
  )
}
